import getBUFromLocalStorage from 'EmailComponents/utils/getBUFromLocalStorage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import ExportModal from 'email-management-lib/refactor/components/manage/frameworkTable/ExportModal';
import { getIsUngatedForAiInsights } from 'email-management-lib/refactor/selectors/user';
import { getIsDeletedView, getIsIssuesView } from 'email-management-lib/refactor/utils/views';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import useBulkActions from 'framework-listing-lib/hooks/useBulkActions';
import ListingLibTableActions from 'framework-listing-lib/table/ListingLibTableActions';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import InsightButton from 'messaging-publishing-lib/Insights/components/InsightButton';
import InsightContextSelect from 'messaging-publishing-lib/Insights/components/InsightContextSelect';
import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FrameworkTableActions() {
  const isIssuesView = getIsIssuesView();
  const [isExportModalOpen, setExportModalOpen] = useState(false);
  const isUngatedForAiInsights = useSelector(getIsUngatedForAiInsights);
  const {
    selectedObjectsCount
  } = useBulkActions();
  const onExportModalClose = useCallback(() => {
    setExportModalOpen(false);
  }, [setExportModalOpen]);
  const businessUnitId = getBUFromLocalStorage();
  const isDeletedView = getIsDeletedView();
  const showRenderExportButton = useMemo(() => {
    return !isIssuesView && !isDeletedView;
  }, [isIssuesView, isDeletedView]);
  const staticColumns = useMemo(() => {
    if (isDeletedView) {
      return [PROPERTIES.NAME, PROPERTIES.DELETED_DATE, PROPERTIES.DELETED_BY_ID];
    } else if (isIssuesView) {
      return [PROPERTIES.NAME, PROPERTIES.ERROR_TAGS, PROPERTIES.ERROR_DATE];
    }
    return [PROPERTIES.NAME];
  }, [isDeletedView, isIssuesView]);
  const shouldRenderInsights = useMemo(() => {
    return isUngatedForAiInsights && !isIssuesView && !isDeletedView;
  }, [isDeletedView, isIssuesView, isUngatedForAiInsights]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [shouldRenderInsights && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      marginInlineEnd: "300",
      "data-test-id": "insights-context-and-button",
      children: [!selectedObjectsCount && /*#__PURE__*/_jsx(InsightContextSelect, {}), /*#__PURE__*/_jsx(InsightButton, {
        businessUnitId: businessUnitId
      })]
    }), /*#__PURE__*/_jsx(ListingLibTableActions, {
      editColumnProps: {
        onSave: () => {
          listingLibObserver.closeEditColumnsModal();
        },
        staticColumns
      }
    }), showRenderExportButton && /*#__PURE__*/_jsx(Button, {
      "data-test-id": "email-export-link",
      marginInlineStart: "300",
      marginInlineEnd: "200",
      onClick: () => setExportModalOpen(true),
      size: "extra-small",
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.modals.export.exportEmails"
      })
    }), /*#__PURE__*/_jsx(ExportModal, {
      isOpen: isExportModalOpen,
      onClose: onExportModalClose
    })]
  });
}